import React from "react";

function Fechamento({ reportData }) {
  return (
    <div className="flex box-border flex-col p-4 gap-12 justify-center items-center w-full">
      {reportData.map((pdv) => (
        <div className="flex box-border flex-col rounded-lg shadow-lg mt-2 p-4 gap-4 justify-center items-center w-full">
          <div className="flex flex-col gap-4 justify-start w-full w-full text-center">
            <h2 className="font-Oswald ">{pdv?.CODPDV}</h2>
            Turno: {pdv?.TURNO} {" | "}
            Responsável: {pdv?.RESPONSAVEL} {" | "}
            Abertura:{" "}
            {pdv?.DATAABERTURATURNO
              ? new Date(pdv?.DATAABERTURATURNO).toLocaleDateString("pt-BR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  timeZone: "UTC",
                })
              : null}{" "}
            {" | "}
            Fechamento:{" "}
            {pdv?.DATAFECHATURNO
              ? new Date(pdv?.DATAFECHATURNO).toLocaleDateString("pt-BR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  timeZone: "UTC",
                })
              : null}
          </div>

          <h3 className="text-center font-Oswald">Produtos Vendidos</h3>
          <div className="box-border overflow-x-auto w-full">
            <table className="min-w-full bg-white border border-solid border-gray-300">
              <thead className="bg-gray-300">
                <tr>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
                    Produto
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
                    Quantidade
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {pdv.produtos.map((row, index) => (
                  <tr
                    key={row?.DESCRICAO + index}
                    className="hover:bg-gray-200"
                  >
                    <td className="font-Roboto px-4 py-2 border-b text-sm">
                      {row.DESCRICAO}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {row.QTDE}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.TOTAL).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                ))}
                <tr className="bg-gray-300">
                  <td className="font-Roboto px-4 py-2 border-b text-sm font-[600]">
                    Total
                  </td>
                  <td></td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
                    {pdv?.totalProdutos.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="text-center font-Oswald">Formas de Pagamento</h3>

          <div className="box-border overflow-x-auto w-full">
            <table className="min-w-full bg-white border border-solid border-gray-300">
              <thead className="bg-gray-300">
                <tr>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[70%]">
                    Forma de Pagamento
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[30%]">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {pdv?.pagamentos.map((row, index) => (
                  <tr
                    key={row?.DESCRICAO + index}
                    className="hover:bg-gray-200"
                  >
                    <td className="font-Roboto px-4 py-2 border-b text-sm">
                      {row.DESCRICAOPGTO}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.VALORPGTO).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                ))}
                <tr className="bg-gray-300">
                  <td className="font-Roboto px-4 py-2 border-b text-sm font-[600]">
                    Total
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm font-[600] text-right">
                    {pdv?.totalPagamentos.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="text-center font-Oswald">Totais</h3>
          <div className="box-border overflow-x-auto w-full">
            <table className="min-w-full bg-white border border-solid border-gray-300">
              <tbody>
                <tr className="hover:bg-gray-200">
                  <td className="font-Roboto px-4 py-2 border-b text-sm">
                    Saldo inicial
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                    {pdv?.TROCOABERTURA.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
                <tr className="hover:bg-gray-200">
                  <td className="font-Roboto px-4 py-2 border-b text-sm">
                    Produtos Vendidos
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                    {pdv?.totalProdutos.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
                <tr className="hover:bg-gray-200">
                  <td className="font-Roboto px-4 py-2 border-b text-sm">
                    Retirada
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right"></td>
                </tr>
                <tr className="hover:bg-gray-200">
                  <td className="font-Roboto px-4 py-2 border-b text-sm">
                    Reforço
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right"></td>
                </tr>
                <tr className="bg-gray-300">
                  <td className="font-Roboto px-4 py-2 border-b text-sm font-[600]">
                    Total
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm font-[600] text-right">
                    {pdv?.totalPagamentos.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Fechamento;
